import EmployeesListing from './EmployeesListing';

export default EmployeesListing;
